import { Options } from 'ky';
import { useErrorHandler } from '../utils';
import useOnLogout from '../library/hooks/user/useOnLogout';
import { useHistory } from 'react-router-dom';

const { FLUZ_WEB_SERVER_URL, FLUZ_BASIC_AUTH_USER, FLUZ_BASIC_AUTH_PASSWORD } = process.env;

interface CommonRequestOptionsConfig {
  token?: string;
  useBasicAuth?: boolean;
  basicAuthUsername?: string;
  basicAuthPassword?: string;
  retry?: boolean; // Default true
}

export default function useCommonRequestOptions() {
  const history = useHistory();
  const onLogOut = useOnLogout();

  function getCommonRequestOptions(route: string, config?: CommonRequestOptionsConfig): Options {
    const baseUrl = FLUZ_WEB_SERVER_URL;
    const prefixUrl = `${baseUrl ? baseUrl : ''}/api/v1/${route}`;

    const { headers, retry } = resolveConfigs(config);

    const commonRequestOptions: Options = {
      prefixUrl,
      headers,
      ...(retry && {
        retry: { methods: ['get', 'post'], limit: 3, statusCodes: [408, 500, 502, 503, 504] },
      }),
      timeout: 60000,
      hooks: {
        afterResponse: [
          async (request, options, response) => {
            if (response.status === 498) {
              onLogOut();
              history.push('/');
            }
          },
        ],
      },
    };
    return commonRequestOptions;
  }

  function resolveConfigs(config?: CommonRequestOptionsConfig) {
    // Headers
    const headers: { [key: string]: string } = {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    };
    if (config) {
      const { token, useBasicAuth, basicAuthUsername, basicAuthPassword } = config;
      const usingAuthenticationScheme = token || useBasicAuth;
      if (usingAuthenticationScheme) {
        headers.Authorization = token
          ? `Bearer ${token}`
          : `Basic ${Buffer.from(
              `${basicAuthUsername ?? FLUZ_BASIC_AUTH_USER}:${basicAuthPassword ?? FLUZ_BASIC_AUTH_PASSWORD}`
            ).toString('base64')}`;
      }
    }

    const retry = typeof config?.retry === 'boolean' ? config.retry : true;

    return { headers, retry };
  }

  return { getCommonRequestOptions };
}
